import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph/alpha';

export const catalogGraphTranslations = createTranslationResource({
  ref: catalogGraphTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
